export default __webpack_public_path__ + "static/media/nativityofblessedvirgin.409518ce.jpg";